import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(3),
    paddingTop: '103px',
    maxWidth: '1200px',
    margin: '0 auto',
    minHeight: '100vh',
    backgroundColor: STYLE.COLOR.WHITE,
    '@media (max-width: 1024px)': {
      paddingTop: '100px',
      maxWidth: '100%',
      padding: theme.spacing(2),
    },
    '@media (max-width: 768px)': {
      paddingTop: '90px',
      padding: theme.spacing(2, 1.5),
      paddingBottom: '45px',
    },
    '@media (max-width: 600px)': {
      paddingTop: '80px',
      paddingBottom: '45px',
    },
    '@media (max-width: 480px)': {
      padding: theme.spacing(1.5, 1),
      paddingTop: '90px',
      paddingBottom: '45px',
    },
  },
  containerWithWarning: {
    paddingTop: '143px',
    '@media (max-width: 1024px)': {
      paddingTop: '140px',
    },
    '@media (max-width: 768px)': {
      paddingTop: '130px',
    },
    '@media (max-width: 600px)': {
      paddingTop: '120px',
    },
    '@media (max-width: 480px)': {
      paddingTop: '130px',
    },
  },
  mainHeader: { left: 0 },

  // Header styles
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    '@media (max-width: 768px)': {
      marginBottom: theme.spacing(3),
    },
  },
  title: {
    fontWeight: 600,
    color: STYLE.COLOR.BLACK,
    fontSize: '32px',
    lineHeight: '39px',
    margin: 0,
    '@media (max-width: 768px)': {
      fontSize: '24px',
      lineHeight: '30px',
    },
    '@media (max-width: 480px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },

  // Tabs row
  tabsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '32px',
    gap: theme.spacing(2),
    '@media (max-width: 960px)': {
      marginBottom: theme.spacing(3),
    },
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  tabs: {
    borderBottom: '0px' + '!important',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: STYLE.COLOR.TEXT1,
      '&.Mui-selected': {
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
        color: STYLE.COLOR.WHITE,
        '& .custom-count-badge': {
          backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
          color: STYLE.COLOR.ACCENT_PRIMARY,
        },
      },
      '@media (max-width: 768px)': {
        fontSize: '14px',
        minWidth: 'auto',
        padding: theme.spacing(1, 1.5),
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '@media (max-width: 480px)': {
      overflowX: 'auto',
      '& .MuiTabs-scroller': {
        overflowX: 'auto !important',
      },
    },
  },
  tab: {
    border: `1px solid ${STYLE.COLOR.BORDER1}` + '!important',
    borderRadius: '8px !important',
    marginRight: '16px' + '!important',
    '@media (max-width: 768px)': {
      marginRight: '8px' + '!important',
    },
    '@media (max-width: 480px)': {
      marginRight: '6px' + '!important',
    },
  },
  customTabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  customCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    flexShrink: 0,
    '@media (max-width: 768px)': {
      gap: theme.spacing(1),
      width: '100%',
      justifyContent: 'flex-start',
    },
  },
  bookButton: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY + '!important',
    color: STYLE.COLOR.WHITE + '!important',
    borderRadius: '42px' + '!important',
    padding: '14px 24px' + '!important',
    fontSize: '14px' + '!important',
    fontWeight: 500 + '!important',
    lineHeight: '24px' + '!important',
    textTransform: 'none' as const,
    whiteSpace: 'nowrap',
    height: 'auto' + '!important',
    '@media (max-width: 480px)': {
      padding: '12px 16px' + '!important',
      fontSize: '13px' + '!important',
    },
  },
  uploadButton: {
    backgroundColor: STYLE.COLOR.WHITE + '!important',
    color: STYLE.COLOR.ACCENT_PRIMARY + '!important',
    border: `1px solid ${STYLE.COLOR.ACCENT_PRIMARY}` + '!important',
    borderRadius: '42px' + '!important',
    padding: '14px 24px' + '!important',
    fontSize: '14px' + '!important',
    fontWeight: 500 + '!important',
    lineHeight: '24px' + '!important',
    textTransform: 'none' as const,
    whiteSpace: 'nowrap',
    height: 'auto' + '!important',
    '@media (max-width: 480px)': {
      padding: '12px 16px' + '!important',
      fontSize: '13px' + '!important',
    },
  },

  // Cards grid
  appointmentsGrid: {
    marginTop: theme.spacing(2),
    '@media (max-width: 768px)': {
      marginTop: theme.spacing(1.5),
    },
  },

  // Appointment card
  appointmentCard: {
    opacity: 1,
    gap: '16px',
    borderRadius: '12px' + '!important',
    borderWidth: '1px',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    boxShadow: '0 16px 20px -8px rgba(228, 231, 233, 0.40)' + '!important',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    gap: '8px',
  },
  cardHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
    minWidth: 0,
  },
  avatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    background: STYLE.COLOR.WARNING_LIGHT,
    borderRadius: '50%',
    fontSize: '18px',
    fontWeight: 600,
    color: STYLE.COLOR.TEXT4,
    flexShrink: 0,
  },
  facilityInfo: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    gap: '2px',
  },
  facilityName: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  appointmentDate: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  menuButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
    flexShrink: 0,
    width: '24px',
    height: '24px',
    color: STYLE.COLOR.ICONS1,
  },
  cardDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  detailLabel: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
  },
  detailValue: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    wordBreak: 'break-word',
  },
  reasonContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '4px',
    maxWidth: '100%',
  },
  reasonText: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    wordBreak: 'break-word',
    display: 'inline',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  reasonTextExpanded: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    display: 'block',
    width: '100%',
  },
  viewMoreLink: {
    color: STYLE.COLOR.ACCENT_PRIMARY,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textDecoration: 'underline',
    display: 'inline',
    width: 'fit-content',
  },

  // Test result specifics
  resultStatusRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
  },
  statusPending: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.WARNING,
    margin: 0,
  },
  statusApproved: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.SUCCESS,
    margin: 0,
  },
  statusDenied: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.ERROR,
    margin: 0,
  },
  attachmentsSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    paddingTop: '16px',
    borderTop: `1px dashed ${STYLE.COLOR.BORDER_DASHED}`,
  },
  attachmentsLabel: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
  },
  attachmentLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    textDecoration: 'underline',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    width: 'fit-content',
    '& svg': {
      fontSize: '16px',
    },
  },

  // Actions menu (mirrors MyCertifications floating menu)
  actionsMenu: {
    position: 'fixed',
    background: STYLE.COLOR.WHITE,
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderRadius: '12px',
    boxShadow: '0px 4px 20px rgba(0, 58, 87, 0.05)',
    zIndex: 1000,
    minWidth: '102px',
    overflow: 'hidden',
  },
  actionsMenuItem: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px 20px',
    background: 'none',
    border: 'none',
    borderBottom: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    textAlign: 'left',
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      background: STYLE.COLOR.BACKGROUND_LIGHT,
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },

  // Empty state
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8, 2),
    textAlign: 'center',
    minHeight: '400px',
  },
  emptyStateTitle: {
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
    marginBottom: theme.spacing(1) + '!important',
  },
  emptyStateSubtitle: {
    color: STYLE.COLOR.TEXT2,
    maxWidth: '400px',
  },

  content: {
    paddingBottom: theme.spacing(2),
  },
  paginationWrapper: {
    padding: theme.spacing(2, 0),
    marginTop: '48px',
    marginBottom: '48px',
    '@media (max-width: 768px)': {
      marginTop: '32px',
      marginBottom: '32px',
    },
    '@media (max-width: 480px)': {
      marginTop: '24px',
      marginBottom: '24px',
      '& .MuiPagination-ul': {
        flexWrap: 'nowrap',
        justifyContent: 'center',
      },
    },
  },

  // Mobile tab dropdown
  tabDropdown: {
    flex: 1 + '!important',
    padding: '14px 16px' + '!important',
    '& .MuiSelect-icon': {
      top: 'calc(50% - 3px)' + '!important',
      right: '16px' + '!important',
    },
  },
  dropdownMenuItem: {
    padding: '12px 16px' + '!important',
    fontSize: '16px' + '!important',
    fontWeight: 400 + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    '&.Mui-selected': {
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY + '!important',
      color: STYLE.COLOR.WHITE + '!important',
      '&:hover': {
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY + '!important',
      },
    },
    '@media (max-width: 480px)': {
      fontSize: '14px' + '!important',
      padding: '10px 12px' + '!important',
    },
  },
}));

export const useStylesDrugTestingModal = makeStyles({
  modal: {
    '& .MuiDialog-paper': {
      width: '680px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      borderRadius: 12,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      '@media (max-width: 600px)': {
        maxWidth: 'calc(100vw - 32px) !important',
        maxHeight: 'calc(100vh - 64px) !important',
        margin: '32px 16px !important',
      },
    },
  },
  modalContent: {
    padding: '24px !important',
    overflow: 'auto !important',
    maxHeight: 'calc(90vh - 200px)',
    flexShrink: 1,
    '@media (max-width: 600px)': {
      maxHeight: 'calc(100vh - 64px - 180px)',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldHint: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: '4px 0 0',
  },
  facilityInfoCard: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    border: `1px solid ${STYLE.COLOR.ACCENT_PRIMARY_LIGHTER2}`,
    borderRadius: '12px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  facilityInfoRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  facilityInfoLabel: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
  },
  facilityInfoValue: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    wordBreak: 'break-word',
  },
  cancelButton: {
    minWidth: '148px !important',
  },
  confirmButton: {
    minWidth: '132px !important',
  },
});
